import { render, staticRenderFns } from "./SchoolSelectorDropdown.vue?vue&type=template&id=626528c2"
import script from "./SchoolSelectorDropdown.vue?vue&type=script&lang=js"
export * from "./SchoolSelectorDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports